/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetBase64DataRequest } from '../models/GetBase64DataRequest';
import type { StringApiResponse } from '../models/StringApiResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class QrCodeDataService {

    /**
     * @param requestBody
     * @returns StringApiResponse Success
     * @throws ApiError
     */
    public static postApiV1QrGetQrData(
        requestBody?: GetBase64DataRequest,
    ): CancelablePromise<StringApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/qr/get-qr-data',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
